import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { PatientMedicalCautionsResponse } from "@/core/types";

import { getMedicalCautions } from "../queryFunctions/getMedicalCautions";
import { memberCarePlanKeys } from "../keyFactory";

type UseMedicalCautionsProps<TData = PatientMedicalCautionsResponse> = {
  patientId: string;
  select?: (data: PatientMedicalCautionsResponse) => TData;
};

type MedicalCautionsQueryOptions = UseQueryOptions<
  PatientMedicalCautionsResponse,
  unknown,
  PatientMedicalCautionsResponse,
  ReturnType<typeof memberCarePlanKeys.medicalCautions>
>;

export function useMedicalCautions<TData = PatientMedicalCautionsResponse>({
  patientId,
  select,
}: UseMedicalCautionsProps<TData>) {
  return useQuery({ ...optionFactory(patientId), select });
}

export function optionFactory(patientId: string) {
  return {
    queryFn: () => getMedicalCautions(patientId),
    queryKey: memberCarePlanKeys.medicalCautions(patientId),
  } satisfies MedicalCautionsQueryOptions;
}
